import {useEffect} from 'react'
import useWebsiteId from '@hooks/useWebsiteId'
import {useApolloQuery as useQuery, useMutate} from 'apollo-hooks'
import gql from 'graphql-tag'

/**
 * Cleans up common preference inconsistencies.
 */
export default function usePreferencesCleaner() {
  const websiteId = useWebsiteId()
  const mutate = useMutate()

  const {preferences} = useQuery({
    query: gql`
      query CheckoutV3PreferencesCleaner($websiteId: ID) {
        preferences: userPreferences(websiteId: $websiteId) {
          _id
          card {
            _id
            deletedAt
          }
        }
      }
    `,
    variables: {websiteId},
    fetchPolicy: 'cache-first'
  })

  useEffect(() => {
    if (preferences?.card?._id && preferences.card.deletedAt) {
      mutate({
        mutation: gql`
          mutation CheckoutV3PreferencesCleanerMutation($websiteId: ID) {
            setUserPreferences(websiteId: $websiteId, cardId: null, paymentType: null) {
              _id
              paymentType
              card {
                _id
              }
            }
          }
        `,
        variables: {websiteId}
      })
    }
  }, [])

  // TODO: Add other inconsistencies here and split into multiple files (1 per handler)
}
